import React, { useEffect } from 'react';
import { OneWorldSyncEnergyLabelProps, OneWorldSyncLoaderInfoProps } from 'types/OneWorldSyncLoaderTypes';
import loadOneWorldSync from 'utilities/oneWorldSync/oneWorldSync-util';

function EnergyLabel(props: OneWorldSyncEnergyLabelProps) {
  const { brand, mpn, ean, option } = props;

  useEffect(() => {
    if (brand) {
      const loaderInfo: OneWorldSyncLoaderInfoProps = {
        brand,
        window,
        option,
        mpn,
        ean,
      };
      loadOneWorldSync(loaderInfo);
    }
  }, [brand]);

  return (
    <div id="cnet-energyInfo" data-testid="oneworldsync-energy-label">
      <div id="ccs-logos" />
      <div id="ccs-product-fiche" />
    </div>
  );
}

export default EnergyLabel;
